/* wsapi3-pag-contact v1.0 */
/* Deploy Version 2026-10-14 10:42:33 */
/* Deploy Version 2026-09-24 19:11:12 */
/* Deploy Version 2026-07-27 16:11:02 */
wsMain.createModule({
  name: "pag-contact",
  version: '1.0',
  updatedAt: '2026-06-02',
  function: 'create',
  create() {
    document.querySelectorAll('[data-wsjs-contact="container"] [data-wsjs-contact]').forEach(inpt => {
      inpt.addEventListener('focusout', (event) => {
        event.target.value = event.target.value.trim();
      });
      inpt.addEventListener('mouseout', (event) => {
        event.target.value = event.target.value.trim();
      });
      inpt.addEventListener('invalid' ,(event) => {
        event.preventDefault();
        event.target.parentNode.setAttribute('data-wsjs-error', 'true');
      });
      inpt.addEventListener('keydown', (event) => {
        try {
          event.target.parentNode.removeAttribute('data-wsjs-error');
        } catch(_) {}
      });
    });

    try {
      document.querySelector('[data-wsjs-contact="Telefone"]').addEventListener('keypress', e => wsMain.data.cellphoneFilter(e));
      document.querySelector('[data-wsjs-contact="Telefone"]').addEventListener('keyup', e => wsMain.data.cellphoneMask(e));
    } catch (err) {}

    // Pré-preenche o e-mail conhecido do visitante (login/identificação/newsletter anteriores)
    try {
      if (typeof ApiWS !== 'undefined' && ApiWS.CustomerEmail) {
        const known = ApiWS.CustomerEmail.get();
        if (known) {
          const emailInp = document.querySelector('[data-wsjs-contact="container"] input[data-wsjs-contact][type="email"]');
          if (emailInp && !emailInp.value) emailInp.value = known;
        }
      }
    } catch (_) {}

    return true;
  },
  async sendContactForm(event) {
    if (event) event.preventDefault();

    let Json = [];
    document.querySelectorAll('input[data-wsjs-contact]').forEach(inpt => {
      let label = inpt.getAttribute('data-wsjs-contact');
      if (label != 'Assunto' && label != 'prodId') {
        Json.push({
          Nome: label,
          Valor: inpt.value
        });
      }
    });

    try {
      Json.push({
        Nome: 'Mensagem',
        Valor: document.querySelector('textarea[data-wsjs-contact]').value
      });
    } catch(err) {}

    document.querySelector('input[type=submit]').setAttribute('disabled', 'true');

    let LV_ID = document.querySelector('#HD_LV_ID').value;
    let ASSUNTO = document.querySelector('[data-wsjs-contact="title"]')?.value || '';
    let PROD_ID = document.querySelector('#LV_HD_PROD_ID')?.value || 'undefined';

    let bodySend = new FormData();
    bodySend.append('tipo', "enviar-json");
    bodySend.append('LV_ID', LV_ID);
    bodySend.append('ASSUNTO', ASSUNTO);
    bodySend.append('PROD_ID', PROD_ID);

    let jsonText = JSON.stringify(Json);
    jsonText = jsonText.substring(1, jsonText.length - 1);
    bodySend.append('Json', jsonText);

    let response;
    try {
      const res = await fetch('/indiqueAJAX/contato.aspx', {
        method: 'POST',
        body: bodySend,
        redirect: 'follow'
      });
      response = await res.text();
      console.log('[pag-contact] status HTTP:', res.status, '| resposta:', response);
    } catch (fetchErr) {
      console.error('[pag-contact] erro no fetch:', fetchErr);
      response = '0';
    }

    // Guarda o e-mail informado (visitante não logado) antes de limpar o formulário
    try {
      const emailInp = document.querySelector('input[data-wsjs-contact][type="email"]');
      if (response == '1' && emailInp && emailInp.value && typeof ApiWS !== 'undefined' && ApiWS.CustomerEmail) {
        ApiWS.CustomerEmail.set(emailInp.value, { source: 'contact' });
      }
    } catch (_) {}

    document.querySelectorAll('[data-wsjs-contact]').forEach(inpt => inpt.value = '');

    if (response == '1') {
      document.querySelector('.contact-message').innerHTML = '<span>Mensagem enviada com sucesso</span>Obrigado por entrar em contato. Responderemos o mais breve poss&iacute;vel.';
      document.querySelector('.contact-message').classList.add('success');
    } else {
      console.warn('[pag-contact] envio falhou — resposta recebida:', JSON.stringify(response));
      document.querySelector('.contact-message').innerHTML = '<span>N&atilde;o conseguimos enviar sua mensagem</span>Revise o formul&aacute;rio e envie sua mensagem novamente.';
      document.querySelector('.contact-message').classList.add('error');
    }

    document.querySelector('.contact-message-container').style.display = 'block';
    setTimeout(() => {
      document.querySelector('.contact-message-container').style.opacity = '1';
    }, 1);

    document.querySelector('input[type=submit]').removeAttribute('disabled');
  }
});
